import React from "react";

// Optional, parent-enabled each week. Both numbers side by side, no winner, no ranking, no prizes.
export const HeadToHead = ({ d, act }) => {
  const h = d.head_to_head;
  return (
    <section className="tc-card p-4 space-y-3" data-testid="family-h2h">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="text-[11px] font-mono uppercase tracking-widest text-tc-muted">This week, side by side</div>
        {d.is_parent && (
          <button data-testid="family-h2h-toggle" onClick={() => act("/family-week/h2h", { on: !d.h2h_enabled })}
            className="rounded-lg border border-white/15 px-3 py-1.5 text-xs">{d.h2h_enabled ? "Turn off" : "Turn on for this week"}</button>
        )}
      </div>
      {!h ? <p className="text-sm text-tc-muted" data-testid="family-h2h-off">Off this week.{d.is_parent ? " You can turn it on for this week only." : ""}</p> : (
        <>
          <div className="grid gap-2 sm:grid-cols-2" data-testid="family-h2h-rows">
            {h.rows.map((r) => (
              <div key={r.first_name + r.is_me} className="rounded-lg border border-white/10 px-3 py-2 text-sm">
                <div className="font-semibold">{r.is_me ? "You" : r.first_name}</div>
                <div className="text-xs text-tc-sub mt-0.5"><span className="font-mono text-tc-txt">{r.xp}</span> XP · <span className="font-mono text-tc-txt">{r.missions}</span> missions this week</div>
              </div>
            ))}
          </div>
          {d.is_parent && h.off_requests?.length > 0 && (
            <div className="flex flex-wrap items-center gap-2 text-sm" data-testid="family-h2h-off-request">
              <span>{h.off_requests.join(", ")} asked to turn off head-to-head.</span>
              <button data-testid="family-h2h-disable" onClick={() => act("/family-week/h2h", { on: false }, "Turned off")} className="rounded-lg bg-tc-coach text-tc-bg font-semibold px-3 py-1 text-xs">Turn off</button>
            </div>
          )}
          {!d.is_parent && (h.i_asked_off
            ? <p className="text-xs text-tc-muted" data-testid="family-h2h-asked">You asked to turn this off. Your parent will see it.</p>
            : <button data-testid="family-h2h-ask-off" onClick={() => act("/family-week/h2h/ask-off", {}, "Your parent will see your request")} className="rounded-lg border border-white/15 px-3 py-1.5 text-xs">Ask to turn off</button>)}
        </>
      )}
    </section>
  );
};
